import { type ReactNode } from 'react'

import { IconMagicSolid } from '@procurify/ui'

import { AiActionButtonStyled } from './styles/AiActionButtonStyled'

export interface IAiActionButtonProps {
  content: ReactNode
  icon?: ReactNode
  type?: 'button' | 'submit'
  disabled?: boolean
  ariaLabel?: string
  analyticsId?: string
  onClick?: () => void
}

const DEFAULT_ICON = <IconMagicSolid block size={16} />

export const AiActionButton = ({
  content,
  icon = DEFAULT_ICON,
  type = 'button',
  disabled,
  ariaLabel,
  analyticsId,
  onClick,
}: IAiActionButtonProps) => {
  return (
    <AiActionButtonStyled
      type={type}
      disabled={disabled}
      aria-label={ariaLabel}
      analyticsId={analyticsId}
      iconComponent={icon}
      onClick={onClick}
    >
      {content}
    </AiActionButtonStyled>
  )
}
